import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input, Upload, ColorPicker } from 'antd';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import { LeftCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import { AddRecord } from '../../layouts/AddRecord';
import { InputField } from '../../layouts/FormFields';
import AddPhoto from '../../assets/images/add.png';
import { MdError } from 'react-icons/md';
import { BiSolidError } from 'react-icons/bi';

const AddProductCategory = () => {
  const { t } = useTranslation(['common']);
  //   const [addStoreResp, setAddStoreResp] = useState({});
  // const [errorObj, setErrorObj] = useState({});
    const [uploadedImg1, setUploadedImg1] = useState('');
    const [loadings, setLoadings] = useState(false);
  
  const [resetModal, setResetModal] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addUserResp, setAddUserResp] = useState({});
  const [imgError1, setImgError1] = useState(false);
  let header = getHeaders();
  const [imageuploading1, setImageUploading1] = useState(false);
 const [largeFile, setLargeFile] = useState(false);
  const [contentType, setContentType] = useState();
  let navigate = useNavigate();
    let [mycolor, setmycolor] = useState(null);

  const [uploadObj, setUploadObj] = useState({});
  const uploadData = async (userDetails) => {
    let user = JSON.parse(localStorage.getItem("user"));
    userDetails.userId = user?.result?.data?.user?.userId;
    try {
      console.log('uploadObj ', userDetails);
      const res = await axios.post(`${app.URL}/api/v1/admin/category/create`, userDetails, { headers: getHeaders() });
      // const res = await axios.post(`http://192.168.100.16:3200/api/v1/admin/category/create`, userDetails, { headers: getHeaders() });

      if (res.data.result.success) {
        setAddUserResp(res.data.result.data);
        setTimeout(goBack, 500);
        message.success(res.data.result.msg);

      } else if (!res.data.result.success) {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setShow(false);
      if (err) console.log(err.response.data.message);
      else return;
    }
  };
   const handleColorChange = (e) => {
     console.log(e.target.value);
     setmycolor(e.target.value);
   };
   const handleColorFromPicker = (value, hex) => {
     console.log('hex is : ', hex);
     setmycolor(hex);
   };

 const beforeUpload1 = (file) => {
   console.log(file);
   if (file) {
     const img = new Image();
     img.src = URL.createObjectURL(file);
     img.onload = () => {
       if (img.width !== 1100 || img.height !== 2000) {
         setImgError1(true);
         return null;
       } else {
         setImgError1(false);

         if (file.type === 'image/jpeg' || file.type === 'image/png') {
           console.log('setting image type');
           setContentType('img');
         } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
         const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
         if (!isJpgOrPng) {
           message.error('You can only upload JPG/PNG file!');
         }
         console.log('file Checked');
         const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
         if (!isLt2M) {
           setLargeFile(true);
           message.error('Image must smaller than 20MB!');
         }
         console.log('message');
         return isJpgOrPng && isLt2M;
       }
     };
   }
 };
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      name: values.name ? values.name : null,
      description: values.description ? values.description : null,
      image:uploadedImg1?uploadedImg1 :null,
      backgroundColor: mycolor,
      displayPosition:values?.displayPosition,
      isActive: values.isActive,
    });
    setResetModal(true);
    setShow(true);
  };

  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
   const handleChange1 = (info) => {
     if (info.file.status === 'uploading') {
       console.log('uploading data');
       if (!imgError1) {
         setUploadedImg1('');
         setImageUploading1(true);
         setLoadings(true);
         return;
       } else {
         setImageUploading1(false);
         setLoadings(false);
         return;
       }
     }
     if (info.file.status === 'done' && !imgError1) {
       // Get this url from response in real world.
       setLargeFile(false);
       console.log(info.file.response);
       info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
       info.file ? setUploadedImg1(info.file.response.result.data.Location) : ' ';
       info.file ? setImageUploading1(false) : ' ';

       getBase64(info.file.originFileObj, (url) => {
         setLoading(false);
         setImageUploading1(false);
         setuploadLogo(false);
       });
     }
   };
  function goBack() {
    navigate('/category/listing', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  return (
    <AddRecord
      loading={loading}
      pageTitle='Add Product Category'
      initialValues={{
        remember: true,
        ['isActive']: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      switchBtn={true}
      addUserResp={addUserResp}
      handleClose={handleClose}
      show={show}
      addMessage='Are you sure you want to add category?'
      goBack={goBack}
      submitData={submitData}
      upload={false}
      inputs={[
        <InputField
          col='col-md-6 col-12'
          name='name'
          rules={[
            {
              required: true,
              message: 'Enter Product Category',
            },
          ]}
          placeholder='Enter Product Category'
          label='Product Category'
          required={true}
        />,
        <InputField
          col='col-md-6 col-12'
          name='description'
          rules={[
            {
              required: true,
              message: 'Enter Product Description',
            },
          ]}
          placeholder='Enter Product Description'
          label='Product Description'
          required={true}
        />,
        <InputField
          col='col-md-3 col-12'
          name='displayPosition'
          rules={[
            {
              required: true,
              message: 'Enter Position ',
            },
          ]}
          placeholder='Enter Position '
          label='Display Position '
          required={true}
        />,
        <InputField
          col='col-md-3 col-11'
          // name='backgroundColor'
          label='Background Color'
          value={mycolor}
          onChange={(e) => handleColorChange(e)}
          rules={[
            {
              required: true,
              message: 'Must select any color',
            },
          ]}
          placeholder='Write hex code of color'
          required={true}
        />,

        <div className='col-1 pt-4'>
          <ColorPicker value={mycolor} onChange={handleColorFromPicker} />
        </div>,

        <div className='col-md-3 media-column mb-2'>
          <label>Image</label>
          <Upload listType='picture-card' className='avatar-uploader ' showUploadList={false} action={`${app.URL}/api/v1/general/product/logoUpload`} beforeUpload={beforeUpload1} onChange={handleChange1} headers={header}>
            {uploadedImg1 && !imageuploading1 ? (
              <img className='added-img' src={uploadedImg1} alt='avatar' />
            ) : !uploadedImg1 && imageuploading1 ? (
              <LoadingOutlined style={{ fontSize: '40px' }} />
            ) : (
              <div className='d-flex flex-column '>
                <img className='for-add-img py-3' src={AddPhoto} alt='avatar' />
                <p className='add-text'>Upload Image</p>
              </div>
            )}
          </Upload>
          <div className='d-flex align-items-center gap-2'>
            {imgError1 ? <BiSolidError size={16} color='red' /> : !uploadedImg1 && !imageuploading1 && <MdError size={16} color='#f2b544' />}
            <p style={{ fontSize: '14px' }}>{imgError1 ? 'The image is not 1100 x 2000 px.' : !uploadedImg1 && !imageuploading1 && 'Note: Upload image size 2MB with 1100 x 2000 px.'}</p>
          </div>
          {uploadedImg1 && (
            <>
              <button
                style={{ backgroundColor: '#F21D2F' }}
                onClick={() => {
                  setUploadedImg1('');
                  setImgError1(false);
                }}
                className='add-btn'
              >
                Remove
              </button>
              <br />
            </>
          )}
          {/* <small className='mt-2 font-weight-light' style={{ fontSize: '14px' }}>
                            Note: Upload max image size 2MB with 1100 x 2000 px.
                          </small> */}
        </div>,
      ]}
    />
  );
};

export default AddProductCategory;
